
const INIT_STATE = {
    dailyActivityLoader: false,
    fetchingLoader: false,
    dailyActivitySuccess: false,
    dailyActivityError: false,
    message: '',
    dailyLivingActivities: {},
    healthCondition: {},
    dailyBaseLine: {},
    redFlags: {},
    settingId: null,
    showSubQuestionModal: false,
    initialValues: {},
    selectedQuestion: null

}

export default (state = INIT_STATE, action) => {
    switch (action.type) {


        case 'SubQuestion-Modal': {
            return {
                ...state,
                showSubQuestionModal: !state.showSubQuestionModal,
                initialValues: action.payload !== null ? { ...action.payload } : {},
                selectedQuestion: action.selectedQuestion
            }

        }

        case 'fetchingSetting_START': {
            return {
                ...state,
                fetchingLoader: true
            }
        }
        case 'getQuestionnaireSetting_SUCCESS': {
            const { _id, dailyLivingActivities, healthCondition, dailyBaseLine, redFlags } = action.payload.Record && action.payload.Record.length && action.payload.Record[0]
            return {
                ...state,
                settingId: _id || null,
                dailyLivingActivities: dailyLivingActivities || {},
                healthCondition: healthCondition || {},
                dailyBaseLine: dailyBaseLine || {},
                redFlags: redFlags || {},
                fetchingLoader: false
            }
        }
        case 'savingDailyLivingActivity_START': {
            return { ...state, dailyActivityLoader: true };
        }
        case 'updateQuestionnaire_SUCCESS': {
            return { ...state, dailyActivityLoader: false, dailyActivitySuccess: true, message: "Record Update Success fully" };
        }
        case 'updateQuestionnaire_FAILURE': {
            return { ...state, dailyActivityLoader: false, dailyActivityError: true, message: "Some Error Occur While Updating Record" };
        }
        case 'dailyLivingActivity_reset_state': {
            return {
                ...state,
                dailyActivityLoader: false,
                dailyActivitySuccess: false,
                dailyActivityError: false,
                message: ''
            }
        }

        default:
            return state;
    }
}
